/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {useThemeMode} from '../theme/useThemeContext';
import {IconProps} from '../types/types';

/*
 * Defines the Design Language System (DLS) No GPS Icon component.
 */
export const NoGpsIcon = ({size = 16, iconColor = dlsColor('caRed')}: IconProps) => {
  // re-renders on a theme mode change so the default color re-resolves ...
  useThemeMode();
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 21' fill='none'>
      <path d='M9.74982 17.3292C13.3843 17.3292 16.3307 14.3829 16.3307 10.7484C16.3307 7.11384 13.3843 4.16748 9.74982 4.16748C6.1153 4.16748 3.16895 7.11384 3.16895 10.7484C3.16895 14.3829 6.1153 17.3292 9.74982 17.3292Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M9.74998 13.5102C11.2754 13.5102 12.5119 12.2737 12.5119 10.7483C12.5119 9.22289 11.2754 7.98633 9.74998 7.98633C8.2246 7.98633 6.98804 9.22289 6.98804 10.7483C6.98804 12.2737 8.2246 13.5102 9.74998 13.5102Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M9.74988 3.74937V1.83301' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M9.74988 19.3329V17.4165' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M2.91636 10.583H1' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M18.4999 10.583H16.5835' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <circle cx='10.1666' cy='11' r='3' fill={iconColor}/>
      <line y1='-0.75' x2='22.6809' y2='-0.75' transform='matrix(0.676095 0.736814 -0.676095 0.736814 2.83215 2)' stroke={dlsColor('white')} strokeWidth='1.5'/>
      <line y1='-0.75' x2='21.3837' y2='-0.75' transform='matrix(0.676095 0.736814 -0.676095 0.736814 2.16663 3.24414)' stroke={iconColor} strokeWidth='1.5'/>
    </svg>
  );
};

export default NoGpsIcon;
